import React, { Component } from "react";
import mainImage from "../../assests/images/10.jpg";

class FeelingProud extends Component {
  render() {
    return <img src={mainImage} alt="Feeling Proud" />;
  }
}

export default FeelingProud;
